(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-magnifier')) {
    customElements.define('product-magnifier', class extends HTMLElement {
      static get observedAttributes() { return ['data-zoom-source'] }

      connectedCallback() {
        this.image = this.querySelector('.product-gallery__image')
        this.lens = this.querySelector('.product-gallery__lens')
        this.button = this.querySelector('.product-gallery__zoom')
        this.events = new AbortController()
        const options = { signal: this.events.signal }
        const move = (event) => {
          if (!this.enabled || event.target.closest('button')) return
          if (event.pointerType !== 'mouse' || !matchMedia('(any-hover: hover) and (any-pointer: fine)').matches) return
          this.moveToPointer(event)
        }
        this.addEventListener('pointerenter', move, options)
        this.addEventListener('pointermove', move, options)
        this.addEventListener('pointerleave', () => { if (!this.locked) this.close() }, options)
        this.addEventListener('pointercancel', () => this.close(), options)
        this.addEventListener('pointerdown', (event) => {
          if (this.locked && !event.target.closest('button')) this.moveToPointer(event)
        }, options)
        this.button.addEventListener('pointerenter', () => { if (!this.locked) this.close() }, options)
        this.button.addEventListener('click', () => {
          if (this.locked) return this.close()
          this.locked = true
          this.button.setAttribute('aria-pressed', 'true')
          this.point = { x: 0.5, y: 0.5 }
          this.open()
        }, options)
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.close()
          if (!this.locked || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return
          event.preventDefault()
          const axis = ['ArrowLeft', 'ArrowRight'].includes(event.key) ? 'x' : 'y'
          const direction = ['ArrowLeft', 'ArrowUp'].includes(event.key) ? -1 : 1
          this.point[axis] = Math.max(0, Math.min(1, this.point[axis] + direction * 0.05))
          this.draw()
        }, options)
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.close()
        }, options)
        this.image.addEventListener('load', () => this.draw(), options)
        this.image.addEventListener('error', () => this.close(), options)
        window.addEventListener('blur', () => this.close(), options)
        window.addEventListener('scroll', () => { if (!this.locked) this.close() }, { ...options, capture: true, passive: true })
        this.resizeObserver = new ResizeObserver(() => this.close())
        this.resizeObserver.observe(this)
        this.attributeChangedCallback()
      }

      disconnectedCallback() {
        this.close()
        this.events?.abort()
        this.resizeObserver?.disconnect()
        this.source = null
      }

      attributeChangedCallback() {
        if (!this.button) return
        this.close()
        this.source = null
        this.enabled = Boolean(this.dataset.zoomSource) && this.image.tagName === 'IMG'
        this.dataset.zoomEnabled = String(this.enabled)
        this.button.hidden = !this.enabled
        this.lens.style.backgroundImage = ''
      }

      moveToPointer(event) {
        const rect = this.getBoundingClientRect()
        this.point = {
          x: Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width)),
          y: Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height))
        }
        this.open()
      }

      open() {
        if (!this.enabled) return
        this.active = true
        if (!this.source) {
          const source = new Image()
          this.source = source
          source.onload = () => {
            if (this.source !== source || !this.isConnected) return
            this.lens.style.backgroundImage = `url("${source.src}")`
            this.draw()
          }
          source.onerror = () => {
            if (this.source !== source) return
            this.close()
            this.enabled = false
            this.dataset.zoomEnabled = 'false'
            this.button.hidden = true
          }
          source.src = this.dataset.zoomSource
        }
        this.draw()
      }

      close() {
        this.active = false
        this.locked = false
        if (this.lens) this.lens.hidden = true
        this.button?.setAttribute('aria-pressed', 'false')
      }

      draw() {
        if (!this.active || !this.source?.complete || !this.source.naturalWidth || !this.image.complete || !this.image.naturalWidth) return
        const viewport = this.getBoundingClientRect()
        const image = this.image.getBoundingClientRect()
        const ratio = this.source.naturalWidth / this.source.naturalHeight
        const width = Math.min(image.width, image.height * ratio)
        const height = width / ratio
        const imageLeft = image.left + (image.width - width) / 2 - viewport.left
        const imageTop = image.top + (image.height - height) / 2 - viewport.top
        const x = this.point.x * viewport.width
        const y = this.point.y * viewport.height
        this.lens.hidden = false
        this.lens.style.width = `${Math.min(360, viewport.width * 0.85, viewport.height * 0.9)}px`
        const radius = this.lens.offsetWidth / 2
        const left = Math.max(0, Math.min(viewport.width - radius * 2, x - radius))
        const top = Math.max(0, Math.min(viewport.height - radius * 2, y - radius))
        const zoom = 1.75
        this.lens.style.left = `${left}px`
        this.lens.style.top = `${top}px`
        this.lens.style.backgroundSize = `${width * zoom}px ${height * zoom}px`
        this.lens.style.backgroundPosition = `${radius - (x - imageLeft) * zoom}px ${radius - (y - imageTop) * zoom}px`
      }
    })
  }
  } catch(e) { console.error(e); }
})();

})();
